import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { AppConfigLoader } from '../../config/app-config.loader';
import { ToastService } from '../services/toast.service';

export const apiErrorToastInterceptor: HttpInterceptorFn = (request, next) => {
  const toast = inject(ToastService);
  const appConfigLoader = inject(AppConfigLoader);

  return next(request).pipe(
    catchError((error: unknown) => {
      const error_ = error as any;
      const authOrigin = new URL(appConfigLoader.activeConfig().auth.issuer).origin;
      const isAuthEndpoint = request.url.startsWith(authOrigin);
      if (error_.status === 400 && !isAuthEndpoint) {
        const description = error_.error.error_description ?? error_.error.message ?? error_.error.error;
        void toast.showBadRequestToast(description);
      }
      return throwError(() => error_);
    })
  );
};
